module.exports = vendor_1ab64a97265868890305;